module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/bg2.c2879fdf.jpg";